import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector, useDispatch } from "react-redux";

import Table from "../../../../../components/ui/Table";
import newSortBy from "../../../../../utils/newSortBy";
import { ISortBy } from "../../../../../types";
import { financialsActions } from "../../../../../reducers/financials";
import { ISpentToPassEvaluation } from "../../../../../api/billing/index.types";
import { BillingAPI, BILLING_API_URLS } from "../../../../../api/billing";
import { getQueryStringByStringValues } from "../../../../ComplianceSearch/utils";
import { PURCHASES_TO_TOOK_EVALUATION_COLUMNS } from "./constants";
import { getSumAndCountPurchasesToTookEvaluation } from "../utils";

interface IProps {
  emails: string;
  periodFilter: {
    startDate: string;
    endDate: string;
  };
}
const PurchasesToTookEvaluation: React.FC<IProps> = ({ emails, periodFilter }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector(
    (state) => state.financials.passersStats.spentToPassEvaluation
  );
  const [dataWithSum, setDataWithSum] = useState<ISpentToPassEvaluation[]>([]);

  const [sortBy, setSortBy] = useState<ISortBy>({ by: "account.id", order: false });
  const handleSortBy = (by: string) => newSortBy({ by, sortBy, setSortBy });

  const { isError, error } = useQuery({
    enabled: !!emails || (!!periodFilter.startDate && !!periodFilter.endDate),
    queryKey: [
      BILLING_API_URLS.spentToPassEvaluation,
      emails,
      sortBy,
      periodFilter.startDate,
      periodFilter.endDate,
    ],
    queryFn: async ({ signal }) => {
      const query = new URLSearchParams();
      query.set("sortBy", sortBy.by);
      query.set("order", sortBy.order ? "asc" : "desc");

      query.set("start_date", periodFilter.startDate);
      query.set("end_date", periodFilter.endDate);

      const emailsQuery = getQueryStringByStringValues("emails", emails);
      const requestQuery = query.toString() + `&${emailsQuery}`;

      dispatch(financialsActions.fetchSpentToPassEvaluationRequest());

      const resposne = await BillingAPI.getSpentToPassEvaluationRequest(requestQuery, signal);
      dispatch(
        financialsActions.fetchSpentToPassEvaluationSuccess(resposne.data.spentToPassEvaluation)
      );
      return resposne;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(financialsActions.fetchSpentToPassEvaluationFailed());
    }
  }, [isError, error]);

  useEffect(() => {
    const sumRow = getSumAndCountPurchasesToTookEvaluation(data);
    //@ts-ignore
    sumRow.account.id = undefined;
    setDataWithSum([...data, sumRow]);
  }, [data]);

  return (
    <Table
      csv_table_name="Spent to pass the evaluation"
      theadTitle="Spent to pass the evaluation"
      columns={PURCHASES_TO_TOOK_EVALUATION_COLUMNS}
      data={data.length ? dataWithSum : []}
      loading={loading}
      extractKey={(row) => row["account.id"]}
      handleSortBy={handleSortBy}
      sortBy={sortBy}
      isDownloadable
      noResultsMessage=""
    />
  );
};

export default PurchasesToTookEvaluation;
